import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AccountDTO} from '../model/accountDTO';
import {AddAccountDTO} from '../model/addAccountDTO';
import {AccountGapDTO} from '../model/accountGapDTO';
import {AddManualAccountDTO} from '../model/addManualAccountDTO';
import {BalanceDTO} from '../model/balanceDTO';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'account';

  constructor(private http: HttpClient) {
  }

  get(id: number) {
    return this.http.get<AccountDTO>(`${this.path}/${id}`);
  }

  add(account: AddAccountDTO) {
    return this.http.post<AccountDTO>(this.path, account);
  }

  addManual(dto: AddManualAccountDTO) {
    return this.http.post<AccountDTO>(`${this.path}/manual` , dto);
  }

  getLastBalance(accountId: number) {
    return this.http.get<BalanceDTO>(`${this.path}/${accountId}/last-balance`);
  }

  clientAccounts(id: number) {
    return this.http.get<Array<AccountDTO>>(`${this.path}/client/${id}`);
  }

  accountsWithUncategorisedTransactions() {
    return this.http.get<Array<AccountDTO>>(`${this.path}/with-uncategorised-transactions`);
  }

  getGaps() {
    return this.http.get<Array<AccountGapDTO>>(`${this.path}/gaps`);
  }

  delete(id: number) {
    return this.http.delete(`${this.path}/${id}`);
  }
}
